<template>
  <el-table-column
    prop="webshop_access"
    sortable
    label="Webshop"
    width="110"
  >
    <template slot-scope="scope">
      <el-tag type="success" size="small" v-if="scope.row.webshop_access">Igen</el-tag>
      <el-tag type="danger" size="small" v-else>Nem</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'webshop_access',
  };
</script>
